import React from 'react'
import Header from './header'



const Notfound = () => {



    return (
        <div style={{ position: "relative" }}>





            <Header></Header>

            <div style={{ textAlign: "center", background: "none", color: "white", border: "0", margin: "0 auto", marginTop: "60px", lineHeight: "45px" }} className="card responsive-card">

                <p>No existe el sitio</p>




            </div>





        </div >
    )
}

export default Notfound;
